import { FunctionComponentElement, useEffect, useMemo, useState } from "react";
import { ErrorInput, NodeInputProps } from "../index";
import "./list.scss";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import UpdateList from "./updateList";
import SetItemList from "./setItemList";
import AddItem from "./addItem";
import { v4 as uuidv4 } from 'uuid';

export interface list {
  id:string
  value:string
} 

//only accept type string / boolean /float /number
let typeReg = new RegExp(/(.*)<((?:string|boolean|float|number))>/);
export const ListInput = ({
  defaultValue,
  value,
  onChange,
  type,
}: NodeInputProps): FunctionComponentElement<NodeInputProps> => {

  const [subType, setSubType] = useState<
    "string" | "boolean" | "float" | "number" | "error"
  >();

  let m = type.match(typeReg);

  const initValue = useMemo(() => {
    const intiValueNode = value ? value : defaultValue ? defaultValue : []
    const initValueforList = intiValueNode.map((val:string) => ({id: uuidv4(),value:val}))
    return initValueforList
  },[])

  const [items,setItems] = useState<list[]>(initValue)

  useEffect(() => {
    
    // @ts-ignore // check if the type values is allowed
    if (m && m.length > 0) setSubType(m[2]);
    else setSubType("error");
  }, [type]);



  // set item after is updated
  const setItem = (index: number, value: list) => {
    const tmpItems = Array.from(items);
    tmpItems[index] = value;
    setItems(tmpItems)
    onChange(tmpItems.map((list) => list.value))

  };

  // remove item by index
  const removeItem = (index: number) => {
    const tempItems = Array.from(items);
    tempItems.splice(index, 1);
    setItems(tempItems)
    onChange(tempItems.map((list) => list.value))

  };

  // update item array when row is dropped
  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    const reorderedItems = Array.from(items);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);
    setItems(reorderedItems)
    onChange(reorderedItems.map((list) => list.value))
  };

  switch (subType) {
    case "boolean" || "float" || "number":
      return (
        <>
          <p>
            {" "}
            le type list&#60;{subType}&#62; n'est pas disponible pour le moment{" "}
          </p>
        </>
      );
    case "string":
      return (
        <div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="orderList">
              {(provided: any) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {items.map((item:list, index:number) => (
                    <Draggable key={item.id} draggableId={item.id} index={index}>
                      {(provided: any) => (
                        <div
                          className="list"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                        >
                          <div className="grid ">
                            
                            <div
                              className="col-1 flex align-items-center justify-content-end"
                              {...provided.dragHandleProps} //the only zone that is draggable
                            >
                              {" "}
                              <i   className="pi pi-bars IconClor" style={{ fontSize: '1.6rem' }}></i>

                            </div>

                            <div className="col-10 ">
                              <SetItemList
                                setValue={(value) => setItem(index, {value:value,id:item.id})}
                                value={item.value}
                              />
                            </div>
                            <div className="col-1  flex justify-content-end">
                              <UpdateList
                                deleteSetter={() => {
                                  removeItem(index);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          <div className="mt-3">
            <AddItem
              newValue={(newValue) => {
                const newItems:list[] = Array.from([...items,{id:uuidv4(),value:newValue}]);
                setItems(newItems)
                onChange(newItems.map((dagValues) => dagValues.value.trim()))
              }}
            />
          </div>
        </div>
      );
    default:
      return <></>;
  }
};
